/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function CreateIcon(props: IconProps) {
	const { color = 'white' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-1057 -30)">
					<g transform="translate(0 1)">
						<path d="M1073 32.514l-8.082 8.081-.672.673-.382.382L1060 42l.351-3.865.352-.351.25-.25 5.723-5.724.703-.704 2.109-2.107 3.513 3.514zm-11.947 8.433l2.46-.352-2.109-2.107-.351 2.46zm1.054-3.163l2.109 2.109 5.27-5.27-2.108-2.11-5.27 5.271zm5.974-5.973l2.108 2.108 1.406-1.406-2.109-2.108-1.405 1.406zM1058 44h12.998v-8h1V45H1057V30.002h8.999v1h-8V44z" />
					</g>
				</StyledG>
			</g>
		</svg>
	);
}

// eslint-disable-next-line import/no-unused-modules
export default CreateIcon;
